export const languages = [
  {
    id: 1,
    name: 'English',
    isDefault: true,
    symbol: 'EN',
    createdAt: '2019-09-09T20:47:39.402Z',
    updatedAt: '2019-09-09T20:47:39.402Z',
    createdBy: null,
    updatedBy: null,
  },
];
